module.exports = __webpack_public_path__ + "img/page01.84d68364.png";